export default __webpack_public_path__ + "assets/a07ee20e7fcd03cf5ac13e6e40cd1ced.png";